import React, { useState } from "react";
import "./component.css";
import "../App.css";
import { libraryUrl } from "./util";
import Link from "./Link";
import { Button } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";

export function Tertiary({ isLink = false }) {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {isLink ? "Submit Feedback here" : "Accepting sponsorships!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isLink
              ? "Found a bug or want a particular feature, submit it here. Thank you!"
              : `This area could be yours to advertise whatever you want. A job
            posting? A personal side project? Reach out!`}
          </DialogContentText>
          <div>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLScYRAs4pwCF-b6O_vVYxrAVvrJKfIkxY7Lm1rd-r4-pN3ILCg/viewform?embedded=true"
              width="550"
              height="600"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
            >
              Loading…
            </iframe>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {isLink ? (
        <Link
          hoverDesc="Change map to dark theme"
          onClick={() => setModalOpen(true)}
        >
          Feedback
        </Link>
      ) : (
        <img
          onClick={() => setModalOpen(true)}
          className="tertiary"
          src={libraryUrl("/img/logo3.png")}
        />
      )}
    </div>
  );
}
